export function initGroupCapacityRules(root = document) {
  const addModal = root.querySelector("#group-capacity-add-modal");
  const deleteModal = root.querySelector("#group-capacity-delete-modal");
  if (!(addModal instanceof HTMLElement) || addModal.dataset.initialized === "1") return;

  const addForm = addModal.querySelector("[data-group-capacity-add-form]");
  const select = addModal.querySelector("#group-capacity-subject");
  const context = addModal.querySelector("[data-group-capacity-add-context]");
  const empty = addModal.querySelector("[data-group-capacity-add-empty]");
  const submit = addModal.querySelector("[data-group-capacity-add-submit]");
  if (!(addForm instanceof HTMLFormElement) || !(select instanceof HTMLSelectElement)) return;

  addModal.dataset.initialized = "1";
  const nativeOptions = Array.from(select.options).map((option) => ({
    option,
    value: option.value,
  }));
  const tomSelectOptions = select.tomselect
    ? Object.values(select.tomselect.options).map((option) => ({ ...option }))
    : [];

  addModal.addEventListener("show.bs.modal", (event) => {
    const trigger = event.relatedTarget;
    if (!(trigger instanceof HTMLElement)) return;

    const section = document.getElementById(trigger.dataset.sectionId || "");
    const usedIds = new Set(
      Array.from(section?.querySelectorAll("[data-group-capacity-subject-id]") || []).map(
        (row) => row.dataset.groupCapacitySubjectId,
      ),
    );

    addForm.action = trigger.dataset.action || "";
    if (context) context.textContent = trigger.dataset.sectionLabel || "";
    addForm.reset();

    if (select.tomselect) {
      select.tomselect.clear(true);
      select.tomselect.clearOptions();
      tomSelectOptions.forEach((option) => {
        if (option.value && !usedIds.has(String(option.value))) select.tomselect.addOption(option);
      });
      select.tomselect.refreshOptions(false);
    } else {
      nativeOptions.forEach(({ option, value }) => {
        const unavailable = value !== "" && usedIds.has(value);
        option.hidden = unavailable;
        option.disabled = unavailable;
      });
    }

    const hasAvailableOptions = nativeOptions.some(({ value }) => value !== "" && !usedIds.has(value));
    empty?.classList.toggle("d-none", hasAvailableOptions);
    if (submit instanceof HTMLButtonElement) submit.disabled = !hasAvailableOptions;
  });

  if (!(deleteModal instanceof HTMLElement)) return;
  const deleteForm = deleteModal.querySelector("[data-group-capacity-delete-form]");
  const subject = deleteModal.querySelector("[data-group-capacity-delete-subject]");
  const fallback = deleteModal.querySelector("[data-group-capacity-delete-fallback]");
  if (!(deleteForm instanceof HTMLFormElement)) return;

  deleteModal.addEventListener("show.bs.modal", (event) => {
    const trigger = event.relatedTarget;
    if (!(trigger instanceof HTMLElement)) return;

    deleteForm.action = trigger.dataset.action || "";
    if (subject) subject.textContent = trigger.dataset.subjectLabel || "";
    if (fallback) fallback.textContent = trigger.dataset.fallback || "";
  });
}